import React from "react";
import "firebase/firestore";
import SitesTable from "../../components/SitesTable/SitesTable";
import ErrorCounts from "../../components/ErrorCounts/ErrorCounts";
import FilterColumn from "../../components/FilterColumn/FilterColumn";
import ContentSearch from "../../components/ContentSearch/ContentSearch";

import "./MainPage.css";

function MainPage({
  sites,
  submitQueries,
  queries,
  limitResults,
  loadMore,
  loading
}) {
  return (
    <div className="main-component__container">
      <ErrorCounts />
      <div className="forms">
        <FilterColumn submitQueries={submitQueries} queries={queries} />
        <ContentSearch />
      </div>

      {loading && <span id="loading">Loading...</span>}

      {sites.length > 0 && (
        <div>
          <SitesTable sites={sites} />

          {loading && <div id="loading">Loading...</div>}

          {sites.length >= limitResults && (
            <button
              className="app__primary-button load-more"
              onClick={loadMore}
            >
              Load More
            </button>
          )}
        </div>
      )}
      {sites.length === 0 && !loading && (
        <h3 className="no-sites">No Sites Found</h3>
      )}
    </div>
  );
}

export default MainPage;
